import 'polyfills'
import React from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
import Root from './Root'

const ROOT_ELEMENT_ID = 'react-root'

function removeReactRoot() {
  Array.from(document.querySelectorAll('#' + ROOT_ELEMENT_ID)).forEach(reactRoot => {
    unmountComponentAtNode(reactRoot)
    reactRoot.remove()
  })
}

function renderReactRoot() {
  removeReactRoot()

  if (!document.querySelector('[data-react-component]')) {
    // Dont render react root, if there are no react components in dom
    return
  }

  const reactRoot = document.createElement('div')
  reactRoot.id = ROOT_ELEMENT_ID
  document.body.appendChild(reactRoot)

  render(<Root />, reactRoot)
}

if (document.body.classList.contains('neos-backend')) {
  document.addEventListener('Neos.NodeCreated', renderReactRoot, false)
  document.addEventListener('Neos.NodeRemoved', renderReactRoot, false)
}

window.addEventListener('load', renderReactRoot, false)
